import apiClient from './client';
import type { KalenderArt, KalenderRhythmus } from '@genealogy-app/shared';

export type CalendarEventType = 'birthday' | 'death_anniversary' | 'marriage_anniversary';

export interface CalendarEvent {
  id: string;
  month: number;
  day: number;
  type: CalendarEventType;
  personName: string;
  /** Beteiligte Personen – bei Hochzeiten zwei. */
  personIds: string[];
  year: number;
  /** Nur bei Geburtstagen: lebt die Person noch? */
  lebt: boolean;
  label: string;
}

export async function fetchCalendarEvents(): Promise<CalendarEvent[]> {
  const { data } = await apiClient.get<CalendarEvent[]>('/calendar');
  return data;
}

// ─── Erinnerungen per E-Mail ────────────────────────────────────────────────

export interface KalenderAboEinstellungen {
  aktiv: boolean;
  arten: KalenderArt[];
  rhythmus: KalenderRhythmus;
  vorlaufTage: number;
  nurRunde: boolean;
  nurLebende: boolean;
}

export interface KalenderAbo extends KalenderAboEinstellungen {
  email: string | null;
  /** Ist ein Mailserver eingerichtet? Sonst kommt vorerst nichts an. */
  versandBereit: boolean;
}

export async function fetchKalenderAbo(): Promise<KalenderAbo> {
  const { data } = await apiClient.get<KalenderAbo>('/calendar/abo');
  return data;
}

export async function saveKalenderAbo(input: KalenderAboEinstellungen): Promise<KalenderAbo> {
  const { data } = await apiClient.put<KalenderAbo>('/calendar/abo', input);
  return data;
}

export async function sendeKalenderVorschau(input: KalenderAboEinstellungen): Promise<{ ereignisse: number }> {
  const { data } = await apiClient.post<{ ereignisse: number }>('/calendar/abo/vorschau', input);
  return data;
}

/**
 * Abbestellen aus der Mail – ohne Anmeldung, deshalb an apiClient vorbei
 * (der würde bei 401 eine Token-Erneuerung versuchen).
 */
export async function kalenderAbbestellen(token: string): Promise<{ baum: string | null }> {
  const antwort = await fetch(`/api/kalender-abbestellen/${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  const body = await antwort.json().catch(() => ({}));
  if (!antwort.ok) throw new Error(body?.message ?? 'Abbestellen fehlgeschlagen.');
  return { baum: body?.baum ?? null };
}
